<div class="col m12">
    <div class="mb_0 mt-10" [class.table_card_sec]="gridTitle!='' || showSearchOption || showExcelDownloadOption">
        <div *ngIf="gridTitle!='' || showSearchOption || showExcelDownloadOption" class="table_pagination_sec">
            <h4 *ngIf="gridTitle!=''" class="process_table_title">{{gridTitle}}
            </h4>
            <div class="p_table_main_sec">
                <ul class="ul_arrow">
                    <li *ngIf="showSearchOption">
                        <a>
                            <mat-form-field>
                                <mat-label for="searchBox">Search</mat-label>
                                <input matInput type="text" [(ngModel)]="searchInput" id="searchBox"
                                    (input)="onSearchChange()">

                                <button *ngIf="searchInput" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="searchInput='';onSearchChange()">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <button matSuffix mat-icon-button aria-label="Search">
                                    <em class="material-icons text-secondary">search</em>
                                </button>
                            </mat-form-field>
                        </a>
                    </li>
                    <li *ngIf="showExcelDownloadOption" (click)="downloadExcel()" title="Export to excel">
                        <a>
                            <em class="material-icons text-success">file_download</em>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="table scroll_table modal-grid">
            <div class="btn-group1 next_prev_btn_sec">
                <a *ngIf="showScrollButton" (click)="scrollGrid('prev')" class="prev-btn btn"
                    title="chevron_left_arrow"><em class="material-icons">chevron_left</em></a>
                <a *ngIf="showScrollButton" (click)="scrollGrid('next')" class="nxt-btn btn"
                    title="chevron_right_arrow"><em class="material-icons">chevron_right</em></a>
            </div>
            <div class="outer_table">
                <div class="scrollable_other_tables">
                    <div class="tableHeaderWrp">
                    </div>
                    <div #scrollableGrid class="scroll_animation">
                        <div class="innner_scroll">
                            <div class="scroll_tables first_table">
                                <table class="other_tables" *ngIf="records_count>0; else NoData">
                                    <thead>
                                        <tr>
                                            <ng-container *ngFor="let col of lstColumns;let i=index">
                                                <th *ngIf="col=='action_checkbox_button'" class="custom_width">
                                                    <mat-checkbox [(ngModel)]="isMasterSel"
                                                        (change)="HeaderCheckBoxChanged($event)">
                                                    </mat-checkbox>
                                                </th>
                                                <th *ngIf="col=='action_icon_Edit'" (click)="sortByColumn(col)"
                                                    class="custom_width"
                                                    [class.highlight-header-cell]="selectedColIndex==i">
                                                    Edit
                                                    <i *ngIf="sortColumnInfo.name==col"
                                                        class="material-icons sort_materialicon">arrow_drop_{{sortColumnInfo.isOrderAsc?'down':'up'}}
                                                    </i>
                                                </th>
                                                <th *ngIf="col=='action_icon_Access'" (click)="sortByColumn(col)"
                                                    class="custom_width"
                                                    [class.highlight-header-cell]="selectedColIndex==i">
                                                    Modify Access
                                                    <i *ngIf="sortColumnInfo.name==col"
                                                        class="material-icons sort_materialicon">arrow_drop_{{sortColumnInfo.isOrderAsc?'down':'up'}}
                                                    </i>
                                                </th>
                                                <th *ngIf="col=='action_icon_Delete'" (click)="sortByColumn(col)"
                                                    class="custom_width"
                                                    [class.highlight-header-cell]="selectedColIndex==i">
                                                    DELETE
                                                    <i *ngIf="sortColumnInfo.name==col"
                                                        class="material-icons sort_materialicon">arrow_drop_{{sortColumnInfo.isOrderAsc?'down':'up'}}
                                                    </i>
                                                </th>

                                                <th *ngIf="!columnsToHide.includes(col) && col!='action_checkbox_button' && col!='action_icon_Edit'&&col!='action_icon_Access' &&col!='action_icon_Delete'"
                                                    (click)="sortByColumn(col)" class="custom_width"
                                                    [class.highlight-header-cell]="selectedColIndex==i">
                                                    {{col.startsWith('action_icon') ||
                                                    col=='action_radio_button' ||
                                                    col=='action_slide_toggle'||
                                                    col=='action_checkbox_button' ?'':
                                                    col.startsWith('action_dropdown_option_')? col.slice(23) :
                                                    col.startsWith('action_dropdown_multi_option_')? col.slice(29): col
                                                    }}
                                                    <i *ngIf="sortColumnInfo.name==col"
                                                        class="material-icons sort_materialicon">arrow_drop_{{sortColumnInfo.isOrderAsc?'down':'up'}}
                                                    </i>
                                                </th>

                                            </ng-container>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let row of lstFilteredData;let rowIndex=index">
                                            <tr [class.highlight-row]="selectedRowIndex==rowIndex"
                                                *ngIf="(rowIndex >= (recordsPerPage*(currentPage-1))) && (rowIndex < (recordsPerPage*currentPage))">
                                                <ng-container *ngFor="let col of lstColumns;let colIndex=index">
                                                    <td *ngIf="!columnsToHide.includes(col)"
                                                        [ngStyle]="getCellStyle(col)"
                                                        (click)="selectedRowIndex=rowIndex;selectedColIndex=colIndex;onCellClick(col, row, rowIndex)">
                                                        <span
                                                            *ngIf="col != 'Attachment' && !col.startsWith('action_icon') && col!='action_radio_button' && col!='action_slide_toggle' && col!='action_checkbox_button'
                                                        && !col.startsWith('action_dropdown_option_') && !col.startsWith('action_dropdown_multi_option_')">
                                                            {{
                                                            ((col=='Email'||col=='Username' || col=='Requested
                                                            By')?(row[col].replace(row[col].slice(4,
                                                            row[col].indexOf('@')),'*'.repeat(7))):row[col]) }}
                                                        </span>
                                                        <i *ngIf="col == 'Attachment' && row.hasOwnProperty('URN') "
                                                            class="material-icons" aria-hidden="true">
                                                            <span>download</span>
                                                        </i>
                                                        <span
                                                            *ngIf="col == 'Attachment' && !row.hasOwnProperty('URN') ">{{
                                                            row[col] }}</span>

                                                        <i *ngIf="col.startsWith('action_icon')"
                                                            class="material-icons theme-text-color {{ row[col] }}"
                                                            style="font-size: 15px;margin-left: 5px;"
                                                            aria-hidden="true"></i>
                                                        <mat-radio-group *ngIf="col=='action_radio_button'"
                                                            name="rbgSelect" fxLayout="column">
                                                            <mat-radio-button value="{{rowIndex}}">
                                                            </mat-radio-button>
                                                        </mat-radio-group>
                                                        <mat-slide-toggle *ngIf="col=='action_slide_toggle'"
                                                            [(ngModel)]="row[col]" color="primary"
                                                            checked="{{ row[col] }}" aria-label="{{ row[col] }}"
                                                            fxLayout="column">
                                                        </mat-slide-toggle>
                                                        <mat-checkbox *ngIf="col=='action_checkbox_button'"
                                                            color="primary" [(ngModel)]="row[col]" value="{{rowIndex}}"
                                                            fxLayout="column">
                                                        </mat-checkbox>
                                                        <span *ngIf="col.startsWith('action_dropdown_option_')">
                                                            <mat-select
                                                                (selectionChange)="onSelectionChange($event.value,rowIndex,col)"
                                                                [style.width.px]="115">
                                                                <mat-option [value]="doc" *ngFor="let doc of row[col]">
                                                                    {{doc.text}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </span>
                                                        <span *ngIf="col.startsWith('action_dropdown_multi_option_')">
                                                            <mat-select multiple [ngModel]="row[col]"
                                                                [compareWith]="compareObjects"
                                                                (selectionChange)="onSelectionMultiChange($event.value,rowIndex,col)"
                                                                [style.width.px]="115">

                                                                <mat-option [value]="doc" *ngFor="let doc of row[col]">
                                                                    {{doc.text}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </span>
                                                    </td>
                                                </ng-container>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="showRecordsPerPageOption || showPagination" class="table_pagination_sec">
            <ul class="ul_arrow">
                <li><span class="paging-info"> Showing {{firstRecord}} to {{lastRecord}} of
                        {{this.lstFilteredData.length}}
                        entries</span></li>
                <li *ngIf="showRecordsPerPageOption" class="records-per-page" title="Records per page">
                    <mat-form-field>
                        <!-- <mat-label>Records per page</mat-label> -->
                        <mat-select [(ngModel)]="recordsPerPage" [attr.role]="null"
                            (selectionChange)="changeRecordsPerPage()">
                            <mat-option [value]="5">5</mat-option>
                            <mat-option [value]="10">10</mat-option>
                            <mat-option [value]="50">50</mat-option>
                        </mat-select>
                    </mat-form-field>
                </li>
            </ul>
            <div class="p_table_main_sec">
                <ul class="ul_arrow">
                    <li *ngIf="showPagination" class="number_arrow_li_first" [class.cur-ban]="currentPage==1"
                        (click)="changePage('prev')" title="chevron_left_arrow">
                        <a><em class="material-icons">chevron_left</em></a>
                    </li>
                    <li *ngIf="showPagination" class="number_arrow_li"><a>{{currentPage}}/{{totalPages}}</a></li>
                    <li *ngIf="showPagination" class="number_arrow_li_first"
                        [class.cur-ban]="totalPages==1 || currentPage==totalPages" (click)="changePage('next')"
                        title="chevron_right_arrow">
                        <a><em class="material-icons">chevron_right</em></a>
                    </li>
                </ul>
            </div>
        </div>

        <ng-template #NoData>
            <table class="other_tables">
                <th class="align_center">No Data Found</th>
            </table>
        </ng-template>
    </div>
</div>